import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import type { LegalDocument } from '../data/legal';
interface LegalModalProps {
  document: LegalDocument | null;
  onClose: () => void;
}
export function LegalModal({
  document: doc,
  onClose
}: LegalModalProps) {
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (!doc) return;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    const previousOverflow = window.document.body.style.overflow;
    window.document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKey);
      window.document.body.style.overflow = previousOverflow;
    };
  }, [doc, onClose]);
  return <AnimatePresence data-id="element-20" data-mp="1ctr82j14kbst">
      {doc && <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-6" role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-21" data-mp="1cuk34mqq1cv4">
          <motion.button type="button" aria-label="Cerrar" onClick={onClose} className="absolute inset-0 h-full w-full cursor-default bg-ink/50" initial={reduceMotion ? undefined : {
        opacity: 0
      }} animate={reduceMotion ? undefined : {
        opacity: 1
      }} exit={reduceMotion ? undefined : {
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-22" data-mp="1fpjd6kpaf3pu" />

          <motion.div className="relative flex max-h-[88vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-2xl bg-white shadow-lift sm:rounded-2xl" initial={reduceMotion ? undefined : {
        opacity: 0,
        y: 24,
        scale: 0.98
      }} animate={reduceMotion ? undefined : {
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? undefined : {
        opacity: 0,
        y: 16,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-23" data-mp="wyigk3bn3k9g">
            <header className="flex items-start justify-between gap-4 border-b border-mist px-6 py-5" data-id="element-24" data-mp="669uxrcy3mdn">
              <div data-id="element-25" data-mp="188bh5blxl1n">
                <h2 id="legal-modal-title" className="text-lg font-bold text-forest" data-id="element-26" data-mp="16otnaaaz1xr">
                  {doc.title}
                </h2>
                <p className="mt-1 text-xs text-faint" data-id="element-27" data-mp="ay1evj1litut">{doc.updated}</p>
              </div>
              <button type="button" onClick={onClose} aria-label="Cerrar" className="-mr-2 -mt-1 rounded-full p-2 text-muted transition-colors duration-200 ease-smooth hover:bg-mist hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-28" data-mp="3je4o3t8cwql9">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-29" data-mp="3ocxy3bofpzgo" />
              </button>
            </header>

            <div className="overflow-y-auto px-6 py-6" data-id="element-30" data-mp="18ljwljd8j6ay">
              {doc.blocks.map(block => <section key={block.heading} className="mb-6 last:mb-0" data-id="element-31" data-mp="13nibksw90wwu">
                  <h3 className="text-sm font-bold text-ink" data-id="element-32" data-mp="13pl17bthoo11">{block.heading}</h3>
                  {block.paragraphs.map(paragraph => <p key={paragraph} className="mt-2 text-sm leading-relaxed text-muted" data-id="element-33" data-mp="1g5uhtjakzvis">
                      {paragraph}
                    </p>)}
                </section>)}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}